"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fields = void 0;
const BankAccounts_1 = require("./payload/BankAccounts");
const Billing_1 = require("./payload/Billing");
const BusinessInformation_1 = require("./payload/BusinessInformation");
const BusinessSize_1 = require("./payload/BusinessSize");
const Collateral_1 = require("./payload/Collateral");
const ContractEntity_1 = require("./payload/ContractEntity");
const ContractFlowMarket_1 = require("./payload/ContractFlowMarket");
const ContractOnboardingType_1 = require("./payload/ContractOnboardingType");
const InStores_1 = require("./payload/InStores");
const MerchantId_1 = require("./payload/MerchantId");
const MerchantPortalAccountEmail_1 = require("./payload/MerchantPortalAccountEmail");
const MerchantPortalAccountRole_1 = require("./payload/MerchantPortalAccountRole");
const MorBusinessInformation_1 = require("./payload/MorBusinessInformation");
const MorEntityAnswers_1 = require("./payload/MorEntityAnswers");
const MorGroupAnswers_1 = require("./payload/MorGroupAnswers");
const OnboardingMetadata_1 = require("./payload/OnboardingMetadata");
const PartnerOverrideId_1 = require("./payload/PartnerOverrideId");
const PaymentProduct_1 = require("./payload/PaymentProduct");
const PlatformAccount_1 = require("./payload/PlatformAccount");
const ReferenceMid_1 = require("./payload/ReferenceMid");
const SensitiveGoods_1 = require("./payload/SensitiveGoods");
const SourceIdentifier_1 = require("./payload/SourceIdentifier");
const TemplateId_1 = require("./payload/TemplateId");
const UnderwritingInquiryEmail_1 = require("./payload/UnderwritingInquiryEmail");
const UpsellStores_1 = require("./payload/UpsellStores");
exports.Fields = {
    bank_accounts: BankAccounts_1.BankAccounts,
    billing: Billing_1.Billing,
    business_information: BusinessInformation_1.BusinessInformation,
    business_size: BusinessSize_1.BusinessSize,
    collateral: Collateral_1.Collateral,
    contract_entity: ContractEntity_1.ContractEntity,
    contract_flow_market: ContractFlowMarket_1.ContractFlowMarket,
    contract_onboarding_type: ContractOnboardingType_1.ContractOnboardingType,
    in_stores: InStores_1.InStores,
    merchant_id: MerchantId_1.MerchantId,
    merchant_portal_account_email: MerchantPortalAccountEmail_1.MerchantPortalAccountEmail,
    merchant_portal_account_role: MerchantPortalAccountRole_1.MerchantPortalAccountRole,
    mor_business_information: MorBusinessInformation_1.MorBusinessInformation,
    mor_entity_answers: MorEntityAnswers_1.MorEntityAnswers,
    mor_group_answers: MorGroupAnswers_1.MorGroupAnswers,
    onboarding_metadata: OnboardingMetadata_1.OnboardingMetadata,
    partner_override_id: PartnerOverrideId_1.PartnerOverrideId,
    payment_product: PaymentProduct_1.PaymentProduct,
    platform_account: PlatformAccount_1.PlatformAccount,
    reference_mid: ReferenceMid_1.ReferenceMid,
    sensitive_goods: SensitiveGoods_1.SensitiveGoods,
    source_identifier: SourceIdentifier_1.SourceIdentifier,
    template_id: TemplateId_1.TemplateId,
    underwriting_inquiry_email: UnderwritingInquiryEmail_1.UnderwritingInquiryEmail,
    upsell_stores: UpsellStores_1.UpsellStores,
};
